import { render, staticRenderFns } from "./TensionsList.vue?vue&type=template&id=26e8f8f2&"
import script from "./TensionsList.vue?vue&type=script&lang=js&"
export * from "./TensionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports